import React from "react";
import ReactMarkdown from "react-markdown";

function RagAnswer({ answer, isLoading }) {
  if (isLoading) {
    return (
      <section className="rag-answer rag-answer--loading" aria-label="AI Yanıtı Üretiliyor">
        <div className="rag-answer__header">
          <span className="rag-answer__icon">✨</span>
          <h2 className="rag-answer__title">Yapay Zeka Yanıtlıyor...</h2>
        </div>
        <div className="rag-answer__content">
          <div className="skeleton-line" style={{ width: '90%' }}></div>
          <div className="skeleton-line" style={{ width: '95%' }}></div>
          <div className="skeleton-line" style={{ width: '80%' }}></div>
        </div>
      </section>
    );
  }

  if (!answer) return null;

  return (
    <section className="rag-answer" aria-label="Yapay Zeka Yanıtı">
      <div className="rag-answer__header">
        <span className="rag-answer__icon">✨</span>
        <h2 className="rag-answer__title">Yapay Zeka Özeti</h2>
      </div>
      <div className="rag-answer__content">
        <ReactMarkdown>{answer}</ReactMarkdown>
      </div>
    </section>
  );
}

export default RagAnswer;
